module.exports = __webpack_public_path__ + "assets/adpoly-facility-parking-transport-services-bulk-upload-template.a9b72ed0.xlsx";